<template >
    <v-col >
        <timeline ref="timeline" :groups="groups" 
            
        :items="items"  :options="options"></timeline>
        <v-dialog v-model="newPlaningPopup">
            <v-card>
                <v-card-title>
                    <span class="headline">Ajouter un planning</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" lazy-validation>
                        <v-autocomplete v-model="item.user" :items="users" 
                        item-text="last_name" return-object
                        label="Nom" required></v-autocomplete>
                        <v-text-field
                            v-model="item.start"
                            label="Date de début"
                            type="datetime-local"
                            required
                            ></v-text-field>
                            <v-text-field
                            v-model="item.end"
                            type="datetime-local"
                            label="Date de fin"
                            required
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Enregistrer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-col>
</template>

<script>
import "vue2vis/dist/vue2vis.css";
import { Timeline } from "vue2vis";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
    name: 'PlanningChart',
    components: {
        Timeline
    },
    computed: {
        ...mapState(['zoneSelected']),
        ...mapGetters(['getTabBarActive']), // Récupérer depuis le getter Vuex
        tabBarActive() {
          return this.getTabBarActive; // Rendre plus lisible
        },
        options() {
            return {
                //interaction: {
                //    hover: true
                //},
                selectable: true,
                editable: true,
                start: this.$moment().subtract(14, 'days'),
                end: this.$moment().add(14, 'days'),
                min: this.$moment().subtract(14, 'days'),
                max: this.$moment().add(14, 'days'),
                height:'250px',
                // on create new item
                onAdd: (item)=> {
                    // console.log('onAdd', item);
                    this.addNewPlanning(item)
                },
                onMove: (item)=> {
                    this.updatePlanning(item)
                },
                onRemove: (item)=> {
                    this.deletePlanning(item)
                },
                
            }
        }
    },
    data() {
        return {
            selectedPlanning:null,
            users: [],
            items:[],
            item:{
                id: 3,
                group: 1,
                start: this.$moment(),
                end: this.$moment().add(1, 'day'),
                content: 'Edouard',
                user:null
            },
            groups: [
                { id: 1, content: '' },
            ],
            newPlaningPopup:false,
            loading: false
        };
    },
    methods: {
        ...mapActions(['toggleTabBar']), // Modifier la valeur via Vuex
        deletePlanning(item){
            // console.log(item)
            this.$directus.items('Planning').deleteOne(item.id).then(()=>{
                // console.log(res)
                this.getPlannings()
            })
        },
        updatePlanning(item){
            // console.log(item)
            this.$directus.items('Planning').updateOne(item.id,{
                date_start: this.$moment(item.start).format('YYYY-MM-DD[T]HH:mm'),
                date_end: this.$moment(item.end).format('YYYY-MM-DD[T]HH:mm'),
                zone: this.zoneSelected?.id,
                user: item.user?.id
            }).then(()=>{
                // console.log(res)
                this.getPlannings()
            })
        },  
        addNewPlanning(item){
            // console.log(item)
            this.item.start = this.$moment(item.start).format('YYYY-MM-DD[T]HH:mm')
            // console.log(this.item.start)
            this.newPlaningPopup = true
        },
        save(){
            this.newPlaningPopup = false
            this.$directus.items('Planning').createOne({
                date_start: this.item.start,
                date_end: this.item.end,
                zone: this.zoneSelected.id,
                user: this.item.user.id
            }).then(()=>{
                // console.log(res)
                this.getPlannings()
            })
        },
        close(){
            this.newPlaningPopup = false
        },
        getSessionsBasedOnSelectedPlanning(){
            this.$directus.items('Sessions').readByQuery({
                filter:{
                    planning: this.selectedPlanning,
                    type:'start'
                },
                fields:['*.*']
            }).then(res=>{
                // get movements based on sessions
                this.$directus.items('Movements').readByQuery({
                    filter:{
                        sessions: res.data[0].id
                    },
                    fields:['*.*']
                }).then(res=>{
                    // console.log('movement', res)
                    this.$store.dispatch('setLastUserMovements', {
                        session: res.data[0].id,
                        movement: res.data[res.data.length -1]
                    })
                })
                // console.log('session', res)
            })
        },
        getPlannings()
        {
            this.$directus.items('Planning').readByQuery({
                filter:{
                    zone: this.zoneSelected?.id
                },
                fields:['*.*']
            })
            .then(res=>{
                 //console.log(res.data)
                this.items = res.data.map(item=>{
                    return {
                        id: item.id,
                        group: 1,
                        start: item.date_start,
                        zone: item.zone,
                        end: item.date_end,
                        content: `${item.zone?.name || 'Libre'} - ${item.user?.last_name || 'Non définie'}`,
                        user:item.user,
                        className: item.state === 'done' ? 'is-done' : 'is-pending'
                    }
                })
                
                console.log("this.items",this.items)
            })
        },  
        getAllUsers()
        {
            this.$directus.items('directus_users').readByQuery()
            .then(res=>{
            this.users = res.data
            })
        },
        selectEventTimeline(item)
        {
            this.selectedPlanning = item.items[0]
            let planning = this.items.find(item=>item.id == this.selectedPlanning)
            // console.log('planing', planning)
            let zone = planning.zone
            console.log(zone)
            this.$store.dispatch('setZoneSelected', zone)
            this.getSessionsBasedOnSelectedPlanning()
            
        }
    },
    mounted()
    {
        this.getAllUsers();
        this.getPlannings();
        this.$refs.timeline.on('select', this.selectEventTimeline);
       
    },
    watch:{
        zoneSelected:{
            deep:true,
            handler(){
                // console.log('zone selected changed')
                this.getPlannings()
            }
        }
    }
}
</script>

<style>
.vis-text {
    color: white!important;
}

.vis-inner {
    color: white;
}

.vis-panel.vis-center {
    border: none!important;
}

.vis-panel {
    border: none!important;
}

.vis-panel.vis-left {
    border: none!important;
}

.vis-center {border: none!important;}

.vis-panel.vis-background.vis-horizontal {
    border: none!important;
}

.vis-timeline.vis-bottom {
    border: none!important;
}

.vis-text.vis-major.vis-h0-h4.vis-today.vis-even {
    border: none!important;
}

.vis-current-time {
    background-color:#F4A900;
}

.vis-grid {
    border: none!important;
}

.vis-item {
    border:none!important;
    border-radius:5px!important;
    background-color: #F4A900;
    z-index: 2;
}

.vis-item.is-pending {
  background-color: orange !important;
  border-color: orange !important;
  color: #fff !important;
}
.vis-item.is-done {
  background-color: green !important;
  border-color: green !important;
  color: #fff !important;
}

.vis-selected{
    background-color: #F4A900!important;
    border:1px solid rgb(255, 255, 255)!important;
    color:white!important;
}
</style>